export default "__VITE_ASSET__BD_711pm__"